var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3941_2650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 1.90735e-06C7.17752 1.90735e-06 0 7.17765 0 16.0001C0 24.8226 7.17752 32 16.0001 32C24.8225 32 32 24.8226 32 16.0001C32 7.17765 24.8225 1.90735e-06 16.0001 1.90735e-06Z",
    fill: "#ADCEEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8794 25.9511C12.6835 23.3969 8.91626 19.9699 4.48047 19.9699V23.849C8.43666 23.849 12.4368 28.8142 13.6443 30.7273L15.612 33.8451L17.068 30.459C17.1604 30.2441 26.4315 8.88151 38.2483 1.60571L36.2144 -1.6972C26.0234 4.57765 17.9821 19.5376 14.8794 25.9511Z",
    fill: "#E1ECF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3941_2650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerIcon);
export default __webpack_public_path__ + "static/media/employerIcon.bef6950a618291b25bbceef6ef5fcb67.svg";
export { ForwardRef as ReactComponent };